var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgButtonSpinner = function SvgButtonSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 6,
    viewBox: "0 0 26 6",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    from: 3,
    to: 3,
    begin: "0s",
    dur: "0.8s",
    values: "3;2;3",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    from: 1,
    to: 1,
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 3,
    r: 2,
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    from: 2,
    to: 2,
    begin: "0s",
    dur: "0.8s",
    values: "2;3;2",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    from: 0.5,
    to: 0.5,
    begin: "0s",
    dur: "0.8s",
    values: ".5;1;.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 3,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    from: 3,
    to: 3,
    begin: "0s",
    dur: "0.8s",
    values: "3;2;3",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    from: 1,
    to: 1,
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))));
};
export default SvgButtonSpinner;